const route = {
    path: "/trade-case",
    name: "TradeCase",
    meta: {
        layout: 'PageLayout'
    },
    children: [
        {
            path: "index",
            name: "TradeCaseList",
            component: () => import("./view/TradeCaseList.vue"),
            meta: {
                title: "贸易案例",
                isRequiredAuth: true
            }
        },
        {
            path: "trade-case-detail",
            name: "TradeCaseDetail",
            component: () => import("./view/TradeCaseDetail.vue"),
            meta: {
                title: "贸易案例详情",
                isRequiredAuth: true
            }
        }
    ]

}

export default route